class FreebiesMeter extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            trackingMsg: this.querySelector("[data-ongoing]"),
            successMsg: this.querySelector("[data-success]"),
            progressBar: this.querySelector("[data-progress-bar]")
        };

        this.cartForm = this.querySelector('cart-form');

        this.elements.trackingMsg.innerHTML =
            this.elements.trackingMsg.innerHTML.replaceAll(
                "[remaining]",
                "<span data-remaining></span>"
            );
        this.elements.trackingMsg.innerHTML =
            this.elements.trackingMsg.innerHTML.replaceAll(
                "[product]",
                "<span data-title></span>"
            );
    }

    static observedAttributes = ["data-cart-total"];

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) return;
        if (name === "data-cart-total") {
            this.reRender();
        }
    }

    connectedCallback() {
        this.setup();
    }

    setup() {
        const cartDrawer = document.querySelector("cart-drawer");
        cartDrawer.dataStore.listen("prices", (data) => {
            this.dataset.cartTotal = currencyAPIObj.money(data.value.original_total_price);
        });
    }

    updateProgressBar() {
        const cartTotal = parseFloat(this.dataset.cartTotal);
        const stepsCount = parseInt(this.querySelector("[data-step-count]").dataset.stepCount);

        const steps = [0];

        for (let i = 1; i < stepsCount; i++) {
            const stepElement = this.querySelector(`[data-step-${i}]`);
            if (stepElement) {
                steps.push(parseFloat(stepElement.dataset.stepAmount));
            }
        }

        const segments = steps.length - 1;
        let totalProgress = 0;

        for (let i = 0; i < segments; i++) {
            let progress = ((cartTotal - steps[i]) / (steps[i + 1] - steps[i])) * 100;
            progress = Math.max(0, Math.min(progress, 100));
            totalProgress += progress;
        }

        totalProgress = segments > 0 ? totalProgress / segments : 0;

        this.elements.progressBar.style.maxWidth = `${totalProgress}%`;
    }

    async updateGiftStatus(stepElement, addGift) {
        const giftId = stepElement.dataset.stepFreeGiftId;
        const stepType = stepElement.dataset.stepType;

        if (stepType === "gift" && giftId) {
            const storedGifts = JSON.parse(localStorage.getItem('addedGifts') || '[]');

            if (addGift && !storedGifts.includes(giftId)) {
                await this.cartForm.formDataAPI.updateItems({
                    id: giftId,
                    quantity: 1,
                });
                this.cartForm.reqCart();
                storedGifts.push(giftId);
                localStorage.setItem('addedGifts', JSON.stringify(storedGifts));
            } else if (!addGift && storedGifts.includes(giftId)) {
                await this.cartForm.formDataAPI.updateItems({
                    id: giftId,
                    quantity: 0,
                });
                this.cartForm.reqCart();
                const updatedGifts = storedGifts.filter(id => id !== giftId);
                localStorage.setItem('addedGifts', JSON.stringify(updatedGifts));
            }
        }
    }

    async updateCompletionStatus() {
        const cartTotal = parseFloat(this.dataset.cartTotal);
        const steps = Array.from(this.querySelectorAll('.freebies-step'));
    
        for (const step of steps) {
            const stepAmount = parseFloat(step.dataset.stepAmount);
            const stepCompleted = step.classList.contains('step-completed');
    
            if (cartTotal >= stepAmount && !stepCompleted) {
                step.classList.add('step-completed');
                await this.updateGiftStatus(step, true);
            } else if (cartTotal < stepAmount && stepCompleted) {
                step.classList.remove('step-completed');
                await this.updateGiftStatus(step, false); 
            }
        }

        this.updateShippingText();
    }

    updateShippingText() {
        const cartTotal = parseFloat(this.dataset.cartTotal);
        const steps = Array.from(this.querySelectorAll('.freebies-step'));
        const nextStep = steps.find(step => !step.classList.contains('step-completed'));

        if (!nextStep) {
            this.elements.successMsg.classList.remove("hidden");
            this.elements.trackingMsg.classList.add("hidden");
        } else {
            this.elements.successMsg.classList.add("hidden");
            this.elements.trackingMsg.classList.remove("hidden");
            const remainingAmount = Math.ceil(nextStep.dataset.stepAmount - cartTotal);
            this.elements.trackingMsg.querySelector("[data-remaining]").textContent = remainingAmount;
            this.elements.trackingMsg.querySelector("[data-title]").textContent = nextStep.dataset.stepName;
        }
    }

    reRender() {
        this.updateProgressBar();
        this.updateCompletionStatus();
    }
}

customElements.define('freebies-meter', FreebiesMeter);